import * as o from "react";
import c from "../lib/IconBase.es.js";
import s from "../defs/ArrowCounterClockwise.es.js";
const r = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(c, { ref: t, ...e, weights: s }));
r.displayName = "ArrowCounterClockwiseIcon";
const i = r;
export {
  i as ArrowCounterClockwise,
  r as ArrowCounterClockwiseIcon
};
